import { END } from '@confluence/navdex/entry-points/NavdexPointType';

export const navdexEnd = {
	attributes: {
		navdexPointType: END,
	},
};
